import { cn } from '@/lib/utils'
import { motion } from 'motion/react'

export function LoadingIndicator({ className }: { className?: string }): React.ReactElement {
  return (
    <motion.svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('origin-center', className)}
      animate={{ rotate: 360, transition: { duration: 1.5, repeat: Infinity, ease: 'linear' } }}
    >
      <g>
        <circle cx="3" cy="12" r="2" />
        <circle cx="21" cy="12" r="2" />
        <circle cx="12" cy="21" r="2" />
        <circle cx="12" cy="3" r="2" />
        <circle cx="5.64" cy="5.64" r="2" />
        <circle cx="18.36" cy="18.36" r="2" />
        <circle cx="5.64" cy="18.36" r="2" />
        <circle cx="18.36" cy="5.64" r="2" />
      </g>
    </motion.svg>
  )
}
